import notificationTypes from './types';

export const initialStates = {
	messages: {},
	updated: null,
};

const notificationReducers = (state = initialStates, action) => {
	switch (action.type) {
		case notificationTypes.FETCH.SUCCESS: {
			return { ...state, messages: action?.payload };
		}

		case notificationTypes.FETCH.CLEAR: {
			return { ...state, messages: {} };
		}

		case notificationTypes.UPDATE.SUCCESS: {
			return { ...state, updated: action?.payload };
		}

		default:
			return state;
	}
};

export default notificationReducers;
